import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import "./shift.css";
import { IShift } from "./interface";
import { State } from "../../state";
import { useSelector } from "react-redux";
import { formatAmount } from '../../util/formatAmount';

export default function Shift(props: any) {
  const [roles, setRoles] = useState<any[]>();
  const [shift, setShift] = useState<IShift>({
    shiftId: 0,
    shiftsEntityId: 0,
    totalEmployeeSale: 0,
    totalCash: 0,
    totalCreditCard: 0,
    totalEmployeeCreditCard: 0,
    employeesDetails: [],
    currentDeficit: 0,
    employeeCreditCardValid: false,
    employeeDeficitAvailable: false,
    shiftValid: false,
    cashValid: false,
    creditCardValid: false,
    isSaving: false,
    isSaveFailed: false,
  });

  const state = useSelector((state: State) => state);
  const stateLanguage = state.languageReducer;
  const [languageData, setLanguageData] = useState<any>();
  const history = useHistory();

  useEffect(() => {
    setLanguageData(stateLanguage);
  }, [stateLanguage]);

  useEffect(() => {
    if (props.roles) {
      setRoles(props.roles);
    }
  }, [props.roles]);

  useEffect(() => {
    setShift(props.shiftDetails);
  }, [props.shiftDetails]);

  const employeeDeficitTable = (shift: any) => {
    if (shift.employeesDetails && shift.employeesDetails.length > 0) {
      return (
        <table className={"table-custom-border"}>
          <thead className={"first-thead"}>
            <tr>
              <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.shiftReview?.table?.employeeName}</th>
              <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.shiftReview?.table?.totalSale}</th>
              <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.shiftReview?.table?.deficit}</th>
              <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.shiftReview?.table?.cashAmount}</th>
              <th className={"custom-th-td custom-th-td-top"}>{languageData?.data?.shiftReview?.table?.creditCardAmount}</th>
            </tr>
          </thead>
          <tbody>
            {shift.employeesDetails.map((employee: any, index: number) => {
              return (
                <tr key={index}>
                  <td className={"custom-th-td"}>{employee.employeeName}</td>
                  <td className={"custom-th-td"}>
                    {formatAmount(employee.totalSale, languageData?.data?.general?.locale)}&#8378;
                  </td>
                  <td
                    className={`custom-th-td ${
                      employee.deficit < -1 ? "warning-font" : "valid-font"
                    }`}
                  >
                    {formatAmount(employee.deficit, languageData?.data?.general?.locale)}&#8378;
                  </td>
                  <td className={"custom-th-td"}>
                    {formatAmount(employee.cashAmount, languageData?.data?.general?.locale)}&#8378;
                  </td>
                  <td className={"custom-th-td"}>
                    {formatAmount(employee.creditCardAmount, languageData?.data?.general?.locale)}&#8378;
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      );
    }
    return null;
  };

  return (
    <div className={"component-custom-border"}>
      <table className={"table-custom-border"} key={shift.shiftId}>
        <thead className={"first-thead"}>
          <tr>
            <th className={"custom-th-td"}>{languageData?.data?.shiftReview?.table?.shiftId}</th>
            <th className={"custom-th-td"}>{languageData?.data?.shiftReview?.table?.totalEmployeeSale}</th>
            <th className={"custom-th-td"}>{languageData?.data?.shiftReview?.table?.currentDeficit}</th>
            <th className={"custom-th-td"}>{languageData?.data?.shiftReview?.table?.totalCash}</th>
            <th className={"custom-th-td"}>{languageData?.data?.shiftReview?.table?.totalCreditCard}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={"custom-th-td"}>{shift.shiftId}</td>
            <td className={"custom-th-td"}>
              {formatAmount(shift.totalEmployeeSale, languageData?.data?.general?.locale)}&#8378;
            </td>
            <td
              className={`custom-th-td ${
                shift.currentDeficit < -1 ? "warning-font" : "valid-font"
              }`}
            >
              {formatAmount(shift.currentDeficit, languageData?.data?.general?.locale)}&#8378;
            </td>
            <td className={"custom-th-td"}>
              {formatAmount(shift.totalCash, languageData?.data?.general?.locale)}&#8378;
            </td>
            <td className={"custom-th-td"}>
              {formatAmount(shift.totalCreditCard, languageData?.data?.general?.locale)}&#8378;
            </td>
          </tr>
        </tbody>
      </table>
      {employeeDeficitTable(shift)}
      <div className={"button-group justify-content-center"}>
        {shift.shiftValid &&
        (roles?.includes("ROLE_USER") || roles?.includes("ROLE_ADMIN")) ? (
          <Button
            disabled={shift.isSaving}
            onClick={() => props.saveButtonClicked(shift.shiftsEntityId)}
          >
            {shift.isSaving && (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            )}{" "}
            {shift.isSaving ? languageData?.data?.shiftReview?.buttons?.saving : languageData?.data?.shiftReview?.buttons?.saveShift}
          </Button>
        ) : null}
        {!shift.cashValid && shift.currentDeficit < 0 && (
          <Button onClick={() => history.push("/cash")}>
            {languageData?.data?.shiftReview?.buttons?.enterCash}
          </Button>
        )}
        {!shift.creditCardValid && shift.currentDeficit < 0 && (
          <Button
            onClick={() =>
              history.push(
                "/creditcard?shiftsentityid=" + shift.shiftsEntityId
              )
            }
          >
            {languageData?.data?.shiftReview?.buttons?.enterCreditCard}
          </Button>
        )}
        {shift.creditCardValid && (
          <Button
            onClick={() =>
              history.push(
                "/employeecreditcard?shiftentityid=" + shift.shiftsEntityId
              )
            }
          >
            {languageData?.data?.shiftReview?.buttons?.enterEmployeeCreditCard}
          </Button>
        )}
      </div>
    </div>
  );
}
